import { ClipboardList } from "lucide-react";
import { SPEC_FIELDS } from "@/constants/productSpecFields";

export const ProductCard = ({ name, image, testId }) => {
  return (
    <div data-testid={testId} className="rounded-xl border border-[#E2E8F0] overflow-hidden bg-white">
      <div className="aspect-[4/3] overflow-hidden bg-[#F2F9F5]">
        <img
          src={image}
          alt={name}
          data-testid={`${testId}-image`}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 data-testid={`${testId}-name`} className="font-heading text-xl font-bold text-[#042D1F] mb-4">
          {name}
        </h3>
        <div
          data-testid={`${testId}-specs`}
          className="rounded-lg border border-dashed border-[#E2E8F0] bg-[#F2F9F5]/50 p-4"
        >
          <div className="flex items-center gap-2 mb-2 text-[#0B4F37]">
            <ClipboardList className="h-4 w-4" strokeWidth={1.8} />
            <span className="text-sm font-semibold">Specifications</span>
          </div>
          <p className="text-xs text-slate-500 leading-relaxed">
            {SPEC_FIELDS.join(" · ")} — available on request.
          </p>
        </div>
      </div>
    </div>
  );
};
